import React, { FC, useState } from "react";

import { InfoBox, Notification, Section } from "@in/component-library";
import { ApiException } from "../../apis/api-error";

interface NewCustomerInfoProps {
  isNewCustomer?: boolean;
  heading: string;
  body: string;
  error?: ApiException;
  errorMessage?: string;
}

const NewCustomerInfo: FC<NewCustomerInfoProps> = ({ isNewCustomer, heading, body, error, errorMessage }) => {
  const [isOpenValue, setIsOpenValue] = useState<"open" | "closed" | "default">("open");

  return isNewCustomer ? (
    <Section collapse className="infoblock">
      <InfoBox
        backgroundColor="blue-50"
        title={heading}
        htmlBody={body}
        onClickDropdown={(e) => {
          setIsOpenValue(isOpenValue !== "open" ? "open" : "closed");
        }}
        isOpen={isOpenValue}
      />
    </Section>
  ) : error ? (
    <Section collapse>
      <h2 dangerouslySetInnerHTML={{ __html: heading }} />
      <Notification fullWidth type="error">
        {errorMessage}
      </Notification>
    </Section>
  ) : null;
};

export default NewCustomerInfo;
